<template>
  <div class="appendix-top">
    <div ref="titleSection" class="anim-wrapper">
      <h1 class="appendix-title">
        <span class="line">Appendix</span>
      </h1>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AppendixTop',
  computed: {
    ...mapState('report_list', ['lang'])
  },
  data() {
    return {
      observer: null
    };
  },
  mounted() {
    const options = {
      rootMargin: '-20% 0px',
      threshold: 0
    };

    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        } else {
          entry.target.classList.remove('is-visible');
        }
      });
    }, options);

    this.observer.observe(this.$refs.titleSection);
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
};
</script>

<style scoped>
.appendix-top {
  text-align: center;
  padding-top: 10vh;
}

.appendix-title {
  font-weight: bold;
  color: #000;
  margin-bottom: 20px;
  font-size: clamp(40px, 5vw, 80px);
}

.appendix-description {
  line-height: 1.6;
  color: #4b4b4b;
  font-size: clamp(22px, 2vw, 32px);
}

.appendix-description.en-font {
  font-size: clamp(17.6px, 1.6vw, 25.6px);
}

.anim-wrapper {
  overflow: hidden;
  padding: 5px 0;
}

.line {
  display: block;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.anim-wrapper.is-visible .line {
  opacity: 1;
  transform: translateY(0);
}

.anim-wrapper.is-visible .line:nth-child(2) {
  transition-delay: 0.2s;
}
.anim-wrapper.is-visible .line:nth-child(3) {
  transition-delay: 0.4s;
}
.anim-wrapper.is-visible .line:nth-child(4) {
  transition-delay: 0.6s;
}
</style>
